import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { useAuth } from "./auth-context";

/**
 * Wraps any subtree that requires the user to be signed in. While the
 * AuthProvider is round-tripping /me on first load we render `null` so
 * we don't flash the protected UI before deciding. Replace with a
 * branded full-screen spinner if/when one exists.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
    const { status } = useAuth();
    const location = useLocation();

    if (status === "bootstrapping") return null;

    if (status === "unauthenticated") {
        // Stash the original target so we can bounce the user back
        // to it after a successful login.
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return <>{children}</>;
}
